export default __webpack_public_path__ + "static/media/icon-hamburger.d6aa2390.svg";